import React from "react";
import APPCONFIG from "../../constants/Config";

export default function TermsOfService({}) {
	let url = APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + "/forms/results/print_ica/00";
	return (
		<React.Fragment>
			<div>

				<p>1. Acceptance of Terms</p>

				<p>By downloading, installing, creating an account, or otherwise accessing or using the Karls Technology mobile app, you agree to be bound by these Terms of Service (''Terms''), the <a target={'_blank'} href={url}>Independent Contractor Agreement</a> (''ICA''), and all applicable laws and regulations.</p>

				<p>2. Purpose of the App</p>

				<p>The App provides a digital platform where users can:</p>

				<p>* View and accept optional service appointments offered by Karls Technology;</p>

				<p>* Manage customer interactions;</p>

				<p>* Submit reports and invoices;</p>

				<p>* Track performance incentives and service metrics.</p>


				<p>3. App Access and Account Security</p>

				<p>You are responsible for maintaining the confidentiality of your login credentials and for all activity under your account. Karls Technology is not liable for losses caused by unauthorized account use. You must promptly notify the Company of any unauthorized access or security breaches.</p>

				<p>4. Use Restrictions</p>

				<p>You agree not to:</p>

				<p>* Misrepresent your identity or qualifications;</p>

				<p>* Use the App for fraudulent, illegal, or deceptive purposes;</p>

				<p>* Attempt to copy, reverse-engineer, or disrupt any part of the App;</p>

				<p>* Use the App to solicit Karls Technology clients or contractors outside the platform.</p>

				<p>Violation may result in termination of access and legal action.</p>


				<p>5. Non-Exclusivity</p>

				<p>Use of the App does not create an exclusive relationship. You are free to perform computer repair services for other entities, provided you do not use Karls Technology's confidential information or client data when doing so.</p>

				<p>6. Intellectual Property</p>

				<p>All software, graphics, logos, and content within the App are the exclusive property of Karls Technology and protected by intellectual property laws. You are granted a limited, revocable, non-transferable license to use the App solely for purposes consistent with the Contractor Agreement.</p>

				<p>7. Data Privacy</p>

				<p>Your data is handled according to the Karls Technology Privacy Policy, incorporated herein by reference. By using the App, you consent to the collection and processing of personal and performance data as needed to manage contractor activities and compliance.</p>

				<p>8. Termination</p>

				<p>Karls Technology reserves the right to suspend or terminate your App access if you:</p>

				<p>* Breach these Terms of Service;</p>

				<p>* Engage in misconduct or fraud; or</p>

				<p>* Become inactive or unavailable for an extended period.</p>

				<p>Upon termination, you must cease all App use and return any confidential materials or client information.</p>


				<p>9. Disclaimers</p>

				<p>The App is provided ''as is'' and ''as available.'' Karls Technology makes no warranties, express or implied, including but not limited to fitness for a particular purpose, reliability, or uninterrupted operation.</p>


				<p>10. Limitation of Liability</p>

				<p>To the maximum extent permitted by law, Karls Technology shall not be liable for indirect, incidental, or consequential damages, including lost profits, arising from use or inability to use the App.</p>


				<p>11. Modifications</p>

				<p>Karls Technology may update these Terms at any time. Continued use of the App after updates constitutes acceptance of the revised Terms. The current version will always be available in the App and on the Karls Technology website.</p>

				<p>12. Entire Agreement</p>

				<p>These Terms, together with the Privacy Policy, constitute the entire agreement between you and Karls Technology regarding use of the App and supersede all prior representations or agreements.</p>

				<p>---</p>

				<p>By selecting ''Save'' within the 'Independent Contractor Time Select' portion of the App, you confirm that you have read, understood, and agree to be bound by these Terms and the ICA.</p>
			</div>
		</React.Fragment>
	)
}